module.exports = function(bootstrap) {
	bootstrap.run(["Service", "services", function (Service, services) {
		new Service({
			name: 'receiptCategories',
			group: "rbsmbl",
			url: "/rbsmbl/x-services/spendingAccount/claim/v1/onlineClaim/setup",
			fetch: function(payload) {
				this.payload = payload;
				return this.get(this.payload);
			}
		});
	}]);
};